// extracted by mini-css-extract-plugin
export var table = "_wm-0";